<template>
  <div v-if="yukleme" class="container-fluid">
    <div class="row">
      <div class="col-3">
        <input class="mt-3" type="file" name="file" id="excelFile" @change="excelExport"/>
      </div>
    </div>
    <div class="row">
    <div class="col-12">
    <div>
      
    </div>

    </div>
    </div>
     <div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
export default {
  data() {
    return {
      //servis:[],
      d1:'',
      d2:'',
      posts : [],
      error :[],
      caris:[],
      ekle:[],
      ayar:this.$request.ayar(),
      sa:'',
      bolge:'',
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      yukleme : true, // sağlayıcı mı ?
      donem : this.$request.donem(),
      rapor :{
        ariza:[],
        malzeme:[]
      }
    }
  },
  created (){
    // yetki gelecek
  },
  methods: {

   excelExport(event) {
        const arrs = [];
        this.ekle = [];
        var input = event.target;
        var reader = new FileReader();
          reader.onload = (e) => {
            var data = reader.result;
            data = new Uint8Array(data);
            var wb = XLSX.read(data, {type : 'array'});
            var sheet = wb.Sheets[wb.SheetNames[0]]; 
            var range = XLSX.utils.decode_range(sheet['!ref']);
            range.s.c = 0;
            range.e.c = 13;
            range.s.r = 1
            //var range = { s: { c: 0, r: 1 }, e: { c: 24, r: 2 } };//A1:A5
            
            for(var R = range.s.r; R <= range.e.r; ++R) {
              var satir = {}
              for(var C = range.s.c; C <= range.e.c; ++C) {
                /* find the cell object */
                //console.log('Row : ' + R); // satır numarası
                //console.log('Column : ' + C); // kolon numarası
                var cellref = XLSX.utils.encode_cell({c:C, r:R}); //hücre adresi A1 B1
                var column = XLSX.utils.encode_cell({c:C, r:''});

                if(!sheet[cellref]) continue; // if cell doesn't exist, move on
                var cell = sheet[cellref]; // type lar t:s,v:0.633,w:15:17
                //console.log(JSON.stringify({[cellref] : cell.w}));
                Object.assign(satir, {[column]:cell.w}) //es2015
               // Object.assign(satir, {[cellref]:cell.w}) //es2015
              }
              this.posts.push(satir)
              
            }
           // console.log(this.posts)
            this.islem(this.posts,this.servisolustur)
          };
        reader.readAsArrayBuffer(input.files[0]);
        
    },
   islem(arr,callback){
     console.log(this.posts)
     callback(arr)
     },
   servisolustur(element){ //element = this.posts
          for (let i = 0, p = Promise.resolve(); i < element.length; i++) {
              p = p.then(_ => new Promise(resolve => //garantiye almak için cari kontrol deki işlemler sadece 300 ms yi karşılayacak die bişey yok
                setTimeout(() => {
                      this.cariekle(
                          {
                          kodu:element[i]['A1'],
                          alias:element[i]['B1'],
                          fid:this.ayar.firmaid,
                          said:0,                        
                          enlem:element[i]['C1'],
                          boylam:element[i]['D1'],
                          ilce:element[i]['E1'],
                          il:element[i]['F1'],
                          adres:element[i]['G1'],
                          adres2:0,
                          telefon:0,
                          cep:0,
                          posta:0 

                          }
                        ).then(()=>{
                           resolve()
                        })
                    
             
                }, 100)
               ))
          }
        },
        // yukarıdaki yavaşlatma işlemini aşaüğdaki post işlemine koymak işlemleri daha da hızlandırabilir.(sadece eklenecek kayıtlarda yavaşlar) Denemelisin mutlaka çözdüm :) aşağıda zaten promise dan data dönmesi bekleniyor, sıkıntı olan kısım yukarıdaki hızlı döngü


        cariekle(element){
          return new Promise((resolve, reject) => {
            this.$request.post('cari/',element).then(res => {
              resolve()
            })
          })
        },

  } //method bitişi
};
</script>
<style scoped>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputfile + label {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
}

.inputfile:focus + label,
.inputfile + label:hover {
    background-color: red;
}
.inputfile + label {
	cursor: pointer; /* "hand" cursor */
}
</style>




// WEBPACK FOOTER //
// src/views/aktarim/cari.vue